import { render, staticRenderFns } from "./otherlist.vue?vue&type=template&id=983633d6&"
import script from "./otherlist.vue?vue&type=script&lang=js&"
export * from "./otherlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports